import { merge } from "theme-ui";
import originalTheme from "@lekoarts/gatsby-theme-minimal-blog/src/gatsby-plugin-theme-ui/index";

const theme = merge(originalTheme, {
  fontSizes: [`1rem`, `1rem`, `1rem`, `1.25rem`, `1.5rem`, `1.875rem`, `2.25rem`]
});

export default theme;